import React, { useState, useEffect } from "react";
import {
	Modal,
	Table,
	Tag,
	Typography,
	Space,
	Card,
	Row,
	Col,
	message,
} from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";

const { Text } = Typography;

const ViewServingDepartmentChangeRecordsModal = ({
	visible,
	onCancel,
	userId,
	userName,
}) => {
	const [loading, setLoading] = useState(false);
	const [records, setRecords] = useState([]);

	useEffect(() => {
		if (visible) {
			fetchRecords();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run only when visible
	}, [visible]);

	const fetchRecords = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get(
				`/users/serving-department-change-records/${userId}/`
			);
			if (response.status === 200) {
				// Sort records by changed_date in descending order (most recent first)
				const sortedRecords = response.data.sort(
					(a, b) =>
						new Date(b.changed_date) -
						new Date(a.changed_date)
				);
				setRecords(sortedRecords);
			}
		} catch (error) {
			message.error(
				"봉사기관 변경 기록을 불러오는데 실패했습니다."
			);
		} finally {
			setLoading(false);
		}
	};

	const getChangeTypeColor = (changeType) => {
		switch (changeType) {
			case "신규":
				return "green";
			case "휴직":
				return "orange";
			case "복직":
				return "blue";
			case "퇴직":
				return "red";
			default:
				return "default";
		}
	};

	const columns = [
		{
			title: "부서명",
			dataIndex: "department_name",
			key: "department_name",
			width: 150,
		},
		{
			title: "변경일",
			dataIndex: "changed_date",
			key: "changed_date",
			width: 120,
			render: (date) => dayjs(date).format("YYYY-MM-DD"),
		},
		{
			title: "변경유형",
			dataIndex: "change_type",
			key: "change_type",
			width: 100,
			render: (changeType) => (
				<Tag color={getChangeTypeColor(changeType)}>
					{changeType}
				</Tag>
			),
		},
		{
			title: "사유",
			dataIndex: "reason",
			key: "reason",
			ellipsis: true,
		},
	];

	return (
		<Modal
			title={
				<Space>
					<HistoryOutlined />
					봉사기관 변경 기록
				</Space>
			}
			open={visible}
			onCancel={onCancel}
			footer={null}
			width={800}>
			{loading ? (
				<div
					style={{
						textAlign: "center",
						padding: "20px",
					}}>
					<Text>기록을 불러오는 중...</Text>
				</div>
			) : (
				<>
					<Card
						size="small"
						style={{ marginBottom: 16 }}>
						<Row>
							<Col span={24}>
								<Text strong>
									성도:{" "}
									{
										userName
									}
								</Text>
							</Col>
						</Row>
					</Card>

					<Table
						dataSource={records}
						columns={columns}
						rowKey="id"
						pagination={{
							pageSize: 10,
							showSizeChanger: true,
							showQuickJumper: true,
							showTotal: (
								total,
								range
							) =>
								`${range[0]}-${range[1]} of ${total} items`,
						}}
						size="small"
						scroll={{ x: 600 }}
					/>

					{records.length === 0 && (
						<div
							style={{
								textAlign: "center",
								padding: "40px 0",
							}}>
							<Text type="secondary">
								봉사기관 변경
								기록이 없습니다.
							</Text>
						</div>
					)}
				</>
			)}
		</Modal>
	);
};

export default ViewServingDepartmentChangeRecordsModal;
